export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.5 2a1 1 0 01.939.655l4.611 12.578 3.524-8.612.068-.135a1 1 0 011.784.135l4.5 11A1.002 1.002 0 0122 19h-3.5v3h-2v-3h-8v3h-2v-3H2a1.002 1.002 0 01-.938-1.345l5.5-15 .064-.14A1 1 0 017.5 2zM3.432 17h8.137L7.5 5.903 3.432 17zm11.059 0h6.019L17.5 9.642 14.49 17z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};